import {createContext} from 'react'

export const EligibilityContext = createContext(null);
